// extracted by mini-css-extract-plugin
module.exports = {"container":"Cjrb_pNOjGBiselEmLixw"};